import React from "react";
import DelegateModal from "design/components/popups/DelegateModal";
import useDelegateUsers from "backend/hooks/workflows/useDelegateUsers";
import { IWFState } from "backend/model/model";
import { t } from "i18next";
import Todo from "design/components/misc/Todo";
import useSubmitEscalateTask from "backend/hooks/workflows/useSubmitEscalateTask";
import { ICardElementWithChildren } from "backend/model/model";
import PeriodChip from "design/components/chips/PeriodChip";
const EscalateModalPopup = (props: {
  elem?: ICardElementWithChildren;
  wfState?: IWFState;
  onClose: () => void;
  isOpen?: boolean;
}) => {
  const { mutate } = useSubmitEscalateTask();
  if (!props.wfState) {
    return null;
  }
  return (
    <DelegateModal
      open={!!props.isOpen}
      onClose={props.onClose}
      onSubmit={(values) => {
        console.log("Escalate values", values);

        const userId = values.find((v) => v.field.fieldName === "user")?.value;
        const message = values.find(
          (v) => v.field.fieldName === "message"
        )?.value;

        if (typeof userId === "string" && typeof message === "string") {
          mutate({
            wfInstanceId: props.elem?.workflowState?.wfInstanceId || "",
            userId,
            message,
          });

          props.onClose();
        }
      }}
      title="Escalate"
      buttonText="Escalate"
      fields={[
        {
          type: "info",
          title: props.elem?.typename || "",
          content: (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              {props.elem?.name} ({props.elem?.workflowState?.period || ""})
            </div>
          ),
        },
        {
          type: "info",
          title: "Responsible",
          fieldName: "user",
          initialValue: props.wfState.userid,
          content: (
            <div>
              <div>{props.wfState.responsible}</div>
              <div>{t(`mytasks.roles.${props.wfState.role}`)}</div>
            </div>
          ),
        },
        {
          title: "Message",
          type: "textarea",
          fieldName: "message",
        },
      ]}
    ></DelegateModal>
  );
};

export default EscalateModalPopup;
